import axios from "axios";
import { Path } from "./Path";
import { handleClearStoredAuth } from "../Share/Func/Storage";

const SKIP_REFRESH_URL_PARTS = ["refresh-token", "login", "admin-login"];

const axiosClient = axios.create({
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

let refreshPromise = null;

const shouldSkipRefresh = (config = {}) => {
  if (config.skipAuthRefresh || config._retry) {
    return true;
  }

  const url = config.url ?? "";
  return SKIP_REFRESH_URL_PARTS.some((part) => url.includes(part));
};

const refreshAccessToken = () => {
  if (!refreshPromise) {
    refreshPromise = axiosClient
      .post(`${Path.urlApi}refresh-token`, {}, { skipAuthRefresh: true })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
};

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status !== 401 ||
      !originalRequest ||
      shouldSkipRefresh(originalRequest)
    ) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      await refreshAccessToken();
      return axiosClient(originalRequest);
    } catch (refreshError) {
      if (refreshError?.response?.status === 401) {
        handleClearStoredAuth();
      } else if (!refreshError?.response) {
        error.isRefreshNetworkError = true;
      }
      return Promise.reject(error);
    }
  }
);

export default axiosClient;
